import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-expense-item',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './expense-item.component.html',
  styleUrl: './expense-item.component.scss'
})
export class ExpenseItemComponent {
  isDisabled: boolean = false;

  @Input() TravelType: string = '';
  @Input() ESS_ExpenseReportRequestId: number = 0;
  @Input() IsReimbursed: boolean = false;
  @Input() EmpMasterId = null;

  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    ESS_ExpenseReportRequestId: null as any,
    ESS_TripMasterId: null,
    SelectType: 'RR',
    EmpMasterId: null,
    TravelType: null as any,
    ESS_ExpenseRequestMainId: null,
    ESS_ExpenseRequestDetailsId: null,
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    private activeModal: NgbActiveModal,
    private expense: ExpenseService,
    protected common: CommonService,
    private session: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
  ) {
    //this.Filter.EmpMasterId = session.GetUserDetails().UserId;
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions }; 
  }

  ngOnInit(): void {
    this.Filter.TravelType = this.TravelType;
    this.Filter.ESS_ExpenseReportRequestId = this.ESS_ExpenseReportRequestId;
    this.Filter.EmpMasterId = this.EmpMasterId;
    this.ESS_ExpenseRequest_SelectGet();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ExpenseRequest_SelectGet() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseRequest_SelectGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = response.Table;
          this.TableDatas.forEach((element: any) => {
            if (element.Attachment != null && element.Attachment != '') {
              element.Attachment = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + element.Attachment
            }
          });

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_ExpenseRequestInsert() {
    //const modalRef = this.modalService.open(ConfirmationComponent);
    //modalRef.componentInstance.Message = 'Do you want to submit?';
    // modalRef.result.then(result => {
    //   if (result) {
    //     this.isDisabled = true;
    //     this.Data.FromDate = this.dateFormat.format(this.Data.FromDateObj);
    //     this.Data.ToDate = this.dateFormat.format(this.Data.ToDateObj);
    //     this.expense.ESS_ExpenseRequestInsert(this.Data).subscribe({
    //       next: (response) => {
    //         if (response.Error_Code == "486") {
    //           const modalRef = this.modalService.open(AlertSuccessComponent, {
    //             size: 'md',
    //             backdrop: 'static',
    //             centered: true,
    //             windowClass: 'confirmation-modal'
    //           });
    //           modalRef.componentInstance.Message = response.Error_Message;
    //           modalRef.result.then((result: any) => {
    //             if (result) {
    //               this.activeModal.close(true);
    //             }
    //           });
    //         } else {
    //           const modalRef = this.modalService.open(AlertWarningComponent, {
    //             size: 'md',
    //             backdrop: 'static',
    //             centered: true,
    //             windowClass: 'confirmation-modal'
    //           });
    //           modalRef.componentInstance.Message = response.Error_Message;
    //           modalRef.result.then((result: any) => { });
    //         }
    //         this.isDisabled = false;
    //       },
    //       complete: () => { },
    //       error: (error) => {
    //         this.isDisabled = false;
    //       },
    //     });
    //   }
    // });
  }

  calTotal() {
    return this.TableDatas.map((e: any) => e.ApprovedAmount != '' && e.ApprovedAmount != null ? parseFloat(e.ApprovedAmount) : 0).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  ESS_ExpenseRequestUpdateAtApproval(ESS_ExpenseReportRequestId: number) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want a reimbursement?';
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.isDisabled = true;
          this.expense.ESS_ExpenseRequestUpdateAtApproval({ SelectType: 'R', ESS_ExpenseReportRequestId: ESS_ExpenseReportRequestId, ESS_ExpenseRequestDetails: [] }).subscribe({
            next: (response) => {
              if (response.Error_Code == '491') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  this.close(result)
                });
                this.isDisabled = false;
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
                this.isDisabled = false;
              }
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => { });
  }

  close(result = false) {
    this.activeModal.close(result);
  }
}
